import {
  Reorder,
  useMotionValue,
  AnimatePresence,
  useDragControls,
} from 'framer-motion'
import { ReactNode, useMemo } from 'react'
import useDragReordering from '@/hooks/useDragReordering'
import useIsTouchable from '@/hooks/useIsTouchable'
import styles from './DragReorder.module.scss'

export interface DragReorderItemProps {
  children: ReactNode
  value?: any[]
  id?: string
  dragHandleSelector?: string // css selector for handle
}

export default function DragReorderItem({ children, value, id }) {
  const { isDraggable, setMovedItemId, isReordering, canDrag } =
    useDragReordering()
  const y = useMotionValue(0)
  const isTouchable = useIsTouchable()
  const controls = useDragControls()

  const shouldDrag = useMemo(() => {
    // if (isTouchable) {
    //   return isDraggable && canDrag && !isReordering
    // }
    return isDraggable && !isReordering
  }, [isTouchable, isDraggable, canDrag, isReordering])

  return (
    <>
      {isDraggable ? (
        <AnimatePresence>
          <Reorder.Item
            value={value}
            id={id}
            style={{ y, position: 'relative' }}
            dragListener={false}
            dragControls={controls}
            onDragStart={() => {
              setMovedItemId(id)
            }}
            className={styles.dragReorderItem}
          >
            <>
              <div
                className={styles.dragHandle}
                onPointerDown={(e) => controls.start(e)}
                style={{ touchAction: 'none' }}
              ></div>
              {children}
            </>
          </Reorder.Item>
        </AnimatePresence>
      ) : (
        children
      )}
    </>
  )
}
